import FutureSightDetails from './FutureSightDetails';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

FutureSightDetails.schema = schema;
FutureSightDetails.defaultProps = getEmptyDefaultProps(schema.templateSettings);

// https://github.com/webpack/webpack/issues/706
export default FutureSightDetails;
